/*
 * Bookkeeping for a Tacton slice's requests. Tacton calls run one at a time,
 * in order, through `tactonRequestQueue`, so writes are never dropped while
 * another request is in flight — several can be in flight at once, and the
 * slice is loading until the last of them has landed. Responses land in
 * order, so the latest one always holds the latest Tacton state.
 */
export var requestStarted = function (dataState) {
    var _a;
    dataState.requestsInFlight = ((_a = dataState.requestsInFlight) !== null && _a !== void 0 ? _a : 0) + 1;
    dataState.isLoading = true;
};
var requestSettled = function (dataState) {
    var _a;
    dataState.requestsInFlight = Math.max(((_a = dataState.requestsInFlight) !== null && _a !== void 0 ? _a : 0) - 1, 0);
    dataState.isLoading = dataState.requestsInFlight > 0;
};
export var requestSucceeded = function (dataState, data) {
    dataState.data = data;
    dataState.errors = undefined;
    dataState.pending = undefined;
    requestSettled(dataState);
};
export var requestFailed = function (dataState, errors, data) {
    dataState.errors = errors;
    if (data)
        dataState.data = data;
    requestSettled(dataState);
};
